import React from "react";
import NavbarEmpresas from "./NavbarEmpresas";

const DashboardEmpresas = () => {
    return <NavbarEmpresas />;
};

export default DashboardEmpresas;
